<template>
  <div v-if="isLogged">
    <nav class="navbar navbar-dark navbar-main" style="z-index: 999; background-color: #020f40">
      <div class="header-container">
        <!-- Primeira linha (sempre visível) -->
        <div class="top-row">
          <router-link to="/" class="navbar-brand">
            <img style="height: 40px" src="../../assets/img/logo_branca.png" />
          </router-link>

          <div class="search-container" v-if="isMapRoute">
            <SearchBar />
          </div>

          <div class="navbar-nav-custom">
            <div class="nav-form-custom">
              <Notifications />

              <div class="nav-item-custom">
                <router-link id="linkFaq" to="/faq">
                  <i class="fa fa-question-circle" style="color: #ffffff" title="Central de ajuda"
                    aria-hidden="true"></i>
                </router-link>
              </div>

              <sideBar :exit="exit" v-if="showSidebar" @close="showSidebar = false" />
              <span class="v-divider d-none d-md-block"></span>
              <div class="version d-none d-md-block">
                <LoggedUser />
              </div>

              <div>
                <button class="menu-toggle-btn" type="button" title="Menu" @click="showSidebar = !showSidebar">
                  <i class="fa fa-bars" style="color: #ffffff" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import sideBar from "./SideBar";
import LoggedUser from "./LoggedUser";
import Notifications from "./Notifications";
import SearchBar from "../../view/map/map/SearchBar.vue";

import { openPopupMessage } from "../../view/map/popup";

export default {
  name: "HeaderApp",
  components: {
    sideBar,
    LoggedUser,
    Notifications,
    SearchBar,
  },
  data() {
    return {
      showSidebar: false,
    };
  },
  computed: {
    ...mapGetters({
      isLogged: "isLogged",
      hasNotification: "hasNotification",
    }),
    isMapRoute() {
      return this.$route.path === "/map";
    },
  },
  methods: {
    exit() {
      this.$router.replace("login", () => {
        // localStore.set(null);
        this.logout();
      });
    },
    openMessage() {
      openPopupMessage();
    },
  },
};
</script>

<style scoped>
/* Definindo altura máxima do navbar */
.navbar {
  max-height: 62px;
  min-height: 62px;
  padding: 0.5rem;
}

.header-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
}

.search-container {
  flex: 1;
  min-width: 30vh;
  max-width: 600px;
  margin-left: 1rem;
}

.mobile-search {
  margin-left: 0;
  max-width: 100%;
}

/* Replicando o comportamento do b-navbar-nav com ml-auto */
.navbar-nav-custom {
  margin-left: auto;
  display: flex;
  align-items: center;
  height: 100%;
}

/* Replicando o comportamento do b-nav-form */
.nav-form-custom {
  display: flex;
  align-items: center;
  gap: 0;
  /* Mantém o espaçamento original */
  height: 100%;
}

/* Replicando o comportamento do b-nav-item */
.nav-item-custom {
  display: flex;
  align-items: center;
  height: 100%;
}

.nav-item-custom a {
  color: #ffffff;
  text-decoration: none;
  display: flex;
  align-items: center;
}

.nav-item-custom a:hover {
  color: rgba(255, 255, 255, 0.75);
}

/* Botão do menu com mesmo estilo do BootstrapVue */
.menu-toggle-btn {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.menu-toggle-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* Ajustando o navbar-brand para ficar centralizado */
.navbar-brand {
  display: flex;
  align-items: center;
  margin-bottom: 0;
}

@media (max-width: 600px) {
  .navbar {
    min-height: unset !important;
    max-height: unset !important;
    height: auto !important;
    padding: 0.5rem;
  }

  .top-row {
    flex-wrap: wrap;
    align-items: stretch;
  }

  .top-row>.navbar-brand {
    order: 1;
  }

  .top-row>.navbar-nav-custom {
    order: 2;
  }

  .top-row>.search-container {
    order: 3;
    width: 100%;
    max-width: 100%;
    justify-content: center;
    /* display: flex; */
    flex-basis: 100%;
    margin-left: 0;
  }
}

/* Slight adjustments for left-side icons (keep header height unchanged) */
.navbar-brand img {
  height: 40px;
  /* explicit to ensure consistent size */
  /* margin-left: 6px; small left spacing */
  display: block;
}

/* If there are small icons next to the brand or in mobile view, keep them vertically centered */
.top-row>.navbar-brand,
.top-row>.search-container {
  display: flex;
  align-items: center;
}

/* Tweak search icon / input adornments spacing (safe, won't change header height) */
.search-container .input-group-text,
.search-container .fa-search {
  margin-left: 6px;
  margin-right: 6px;
  line-height: 1;
}

.search-container .overlay-container {
  overflow: unset !important;
}

/* Make left-side icons match the notification icon size and adjust spacing */
.nav-item-custom i,
.menu-toggle-btn i,
.nav-item-custom .fa {
  font-size: 1.3333333em;
  /* match FontAwesome .fa-lg */
  color: #ffffff !important;
  line-height: 1;
  display: inline-block;
  width: 28px;
  /* fixed box so icons align uniformly */
  text-align: center;
}

/* Slightly reduce padding and add consistent gap between icon items (won't change header height) */
.nav-form-custom>.nav-item-custom {
  padding: 0 0.35rem;
  /* keep vertical padding same, adjust horizontal */
  margin-left: 4px;
  margin-right: 4px;
}

/* Ensure notification bell layout is preserved */
.notification-bell {
  display: inline-block;
}

.v-divider {
  width: 1px;
  height: 22px;
  background: #FFF;
  display: inline-block;
  margin-right: 20px;
  margin-left: 10px;
}
</style>
